export const GET_ZOHO_ACCESS="GET_ZOHO_ACCESS"
export const GET_ZOHO_ACCESS_SUCCESS="GET_ZOHO_ACCESS_SUCCESS"
export const GET_ZOHO_ACCESS_FAILED="GET_ZOHO_ACCESS_FAILED"
export const GET_ZOHO_COUNT="GET_ZOHO_COUNT"
export const GET_ZOHO_COUNT_SUCCESS="GET_ZOHO_COUNT_SUCCESS"
export const GET_ZOHO_COUNT_FAILED="GET_ZOHO_COUNT_FAILED"
export const EXPORT_ZOHO_PROCESS="EXPORT_ZOHO_PROCESS"
export const EXPORT_ZOHO_PROCESS_SUCCESS="EXPORT_ZOHO_PROCESS_SUCCESS"
export const EXPORT_ZOHO_PROCESS_FAILED="EXPORT_ZOHO_PROCESS_FAILED"
export const GET_EXPORT_ZOHO_DATA="GET_EXPORT_ZOHO_DATA"
export const GET_EXPORT_ZOHO_DATA_SUCCESS="GET_EXPORT_ZOHO_DATA_SUCCESS"
export const GET_EXPORT_ZOHO_DATA_FAILED="GET_EXPORT_ZOHO_DATA_FAILED"
export const GET_LOGS_ZOHO_DATA="GET_LOGS_ZOHO_DATA"
export const GET_LOGS_ZOHO_DATA_SUCCESS="GET_LOGS_ZOHO_DATA_SUCCESS"
export const GET_LOGS_ZOHO_DATA_FAILED="GET_LOGS_ZOHO_DATA_FAILED"
export const LOGOUT_ZOHO_SUCCESS="LOGOUT_ZOHO_SUCCESS"
export const LOGOUT_ZOHO_FALIED="LOGOUT_ZOHO_FALIED"
export const LOGOUT_ZOHO="LOGOUT_ZOHO"